// @flow
import React from 'react';

import CardGoal from 'components/shared/Goal/index';

type PublicGoalsProps = {
  goals: Array<any>,
  owner: any
}

const PublicGoals = (props: PublicGoalsProps) => {
  const { goals, owner } = props;

  if (!goals) {
    return null;
  }

  return (
    <>
      <div className="container">
        <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
          <div className="pnl kid-dashboard">
            <div className="dashboard-cards">
              {
                goals.map((goal, idx) => (
                  <CardGoal
                    owner={owner}
                    data={goal}
                    aloneView={false}
                    idx={idx}
                  />
                ))
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicGoals;
